import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { WARNING_BAR } from '../constants/warningBar'
import { sanitizeText } from '../utils/security';

type ModeType = keyof typeof WARNING_BAR.mode // "hide" | "show"
type TypeType = keyof typeof WARNING_BAR.type // "error" | "connectionError" | "agentError" | "permissionError" | "communicationError" | "info" | "success" | "successServicingCancel" | "warning" | "recalculatePrinceIsMissingError"
type ModeValueType = (typeof WARNING_BAR.mode)[ModeType] // "Hide" | "Show"
type NotificationType = (typeof WARNING_BAR.type)[TypeType] // "Error" | "ConnectionError" | "AgentError" | "PermissionError" | "CommunicationError" | "Info" | "Success" | "SuccessServicingCancel" | "Warning" | "RecalculatePrinceIsMissingError"

type LabelTypes = {
  label: string
  type: NotificationType
}

type WarningOptions = {
  defaultWarning?: NotificationType
  labelTypes?: LabelTypes[]
  linkLabel?: string
  mode?: ModeValueType
  modal?: boolean
}

type NotificationsProps = {
  type?: NotificationType
  labelTypes: string[]
  linkLabel?: string
  mode?: ModeValueType
  modal?: boolean
}

type WarningStore = {
  options: WarningOptions
  setWarningOptions: (options: NotificationsProps) => void
}

export const useWarningStore = create<WarningStore>()(
  devtools(
    (set) => ({
      options: {
        defaultWarning: WARNING_BAR.type.error,
        labelTypes: [],
        linkLabel: '',
        mode: WARNING_BAR.mode.hide,
        modal: true,
      },
      setWarningOptions: (options: NotificationsProps) =>
        set({
          options: {
            ...options,
            defaultWarning: options.type || WARNING_BAR.type.error,
            labelTypes:
              options.labelTypes?.map((item) => ({
                label: sanitizeText(item),
                type: options.type || WARNING_BAR.type.error,
              })) || [],
            linkLabel: '',
            mode: options.mode
              ? options.mode
              : options.labelTypes.length > 0
              ? WARNING_BAR.mode.show
              : WARNING_BAR.mode.hide,
            modal: options.modal || true,
          },
        }),
    }),
    { name: 'WarningStore' },
  ),
)
